import { Module } from "vuex";
import { RootState, PantryState } from "@/types/pantry";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: PantryState = {
  tagGroups: null,
  searchRecipes: null,
  recommendRecipes: null,
  pantryList: null,
  pantryVirtualList: null,
  pantryDetail: null,
  pantryPlateDetail: null,
  pantryPlateSettingWeight: null,
  pantryConsumeFoods: null,
  pantryFridgeListInfo: null,
  recognitionCandidateMap: null,
  pantryFridgeDetail: null,
  recipeFoods: null,
  recipeFoodMap: null,
  usedUpPantryList: null,
  rankingFoods: null,
  favotiteFoods: null,
  menuCategoies: null,
  purChasedFoods: null,
  products: null,
  plateDeviceMode: null,
  foodRecommendationList: null,
  foodConsumeList: null,
  favoriteFoodStatus: null,
  fridgeItemsJudge: null,
  addFoodItems: null,
  deleteFoodItems: null,
  cameraImageMap: null,
  cameraImageUrlMap: null
};

export const pantry: Module<PantryState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
